/* ==========================================================================
   Tracking + UTM capture
   Ships as: assets/event-track.js  (loaded with defer)

   Two jobs:
   1. fire a named event whenever a [data-track] element is clicked, and treat
      every WhatsApp / tel: click as a conversion — for a high-ticket enquiry
      funnel those carry the same intent as a form submit, and Meta needs the
      volume to optimise
   2. capture UTM / click IDs into sessionStorage and mirror them into the
      booking form's hidden fields, so a lead is still attributable after the
      visitor bounces between the landing page and the form

   Wire the send() body to whatever the store actually loads. Nothing here
   assumes a specific tag manager.
   ========================================================================== */

(function () {
  'use strict';

  /* ---- 1. event dispatch ------------------------------------------------ */

  // Events worth counting as conversions, not just interactions.
  var CONVERSIONS = ['whatsapp_click', 'call_click', 'booking_submitted'];

  function send(name, params) {
    params = params || {};

    // GA4 / Google Tag
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }

    // GTM dataLayer
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, params));
    }

    // Meta Pixel — standard event for conversions, custom otherwise.
    // Pair this with the Conversions API server-side: browser-only tracking
    // undercounts badly on iOS.
    if (typeof window.fbq === 'function') {
      if (CONVERSIONS.indexOf(name) !== -1) {
        window.fbq('track', 'Lead', Object.assign({ content_name: name }, params));
      } else {
        window.fbq('trackCustom', name, params);
      }
    }
  }

  window.eventTrack = send;   // so event-booking.js can reuse it

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track], a[href^="https://wa.me"], a[href^="tel:"], a[href^="mailto:"]');
    if (!el) return;

    var name = el.getAttribute('data-track');
    if (!name) {
      var href = el.getAttribute('href') || '';
      if (href.indexOf('https://wa.me') === 0) name = 'whatsapp_click';
      else if (href.indexOf('tel:') === 0) name = 'call_click';
      else if (href.indexOf('mailto:') === 0) name = 'email_click';
    }
    if (!name) return;

    send(name, {
      link_url: el.getAttribute('href') || '',
      link_text: (el.textContent || '').trim().slice(0, 60)
    });
  }, true);

  /* ---- 2. UTM capture --------------------------------------------------- */

  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
              'gclid', 'fbclid', 'wbraid', 'gbraid', 'msclkid'];
  var STORE_KEY = 'db-event-attribution';

  function readStored() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY)) || {}; }
    catch (e) { return {}; }
  }

  function capture() {
    var params = new URLSearchParams(window.location.search);
    var data = readStored();
    var touched = false;

    KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) { data[k] = v; touched = true; }
    });

    // first touch wins for these two — don't overwrite on internal navigation
    if (!data.landing_page) { data.landing_page = window.location.pathname; touched = true; }
    if (!data.referrer) {
      var ref = document.referrer || '';
      if (ref.indexOf(window.location.host) === -1) { data.referrer = ref; touched = true; }
    }

    if (touched) {
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify(data)); } catch (e) {}
    }
    return data;
  }

  var attribution = capture();

  // mirror into the booking form so the values post with the enquiry
  var form = document.getElementById('booking-form');
  if (form) {
    Object.keys(attribution).forEach(function (k) {
      if (!attribution[k]) return;
      var field = form.querySelector('[name="' + k + '"]');
      if (field) { field.value = attribution[k]; return; }
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = k;
      input.value = attribution[k];
      form.appendChild(input);
    });
  }
})();
